import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup, Alert, Checkbox, ControlLabel } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import { handleFieldChange } from "../../../../Utils";

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: '',
            hour: '',
            minute: '',
            source: null,
            affid: null,
            country: null,
            groupBy: {},
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleGroupByChange = this.handleGroupByChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit() {
        const isValid = this.validateForm();
        const filters = { ...this.state };
        filters.groupBy = Object.keys(filters.groupBy);

        delete filters.alert;

        if(isValid) this.props.onSubmit(filters);
    }

    handleGroupByChange({ target }) {
        const groupBy = { ...this.state.groupBy };
        const { name, checked } = target;

        if(checked) groupBy[name] = 1;
        else delete groupBy[name];

        this.setState({ groupBy });
    }

    validateForm() {
        const { date, groupBy } = this.state;

        let alert = null;

        if(!Object.keys(groupBy).length) alert = 'Please set Group';
        if(!date) alert = 'Please set Day';

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={12}>
                        <ControlLabel>Group By:</ControlLabel>
                        <Checkbox onChange={this.handleGroupByChange} name="date">Date</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="source">Source</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="code">Code</Checkbox>
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="date"
                            label="Day:"
                            onChange={this.handleFieldChange}
                            value={this.state.date}
                        />
                    </Col>
                     <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="hour"
                            label="Hour:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hour}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="minute"
                            label="Minute:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.minute}
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={this.props.sources}
                            label="Sources:"
                            name="source"
                            onChange={this.handleFieldChange}
                            value={this.state.source}
                            multi
                            required
                        />
                    </Col>

                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit()}>Load</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/BidderError/components/Form/index.js